export default __webpack_public_path__ + "static/media/trezi_logo.fa435e12.png";